import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { ActivityIcon, ArrowRightIcon } from "~/components/common/icons";

export type ServiceOffered = {
  name: string;
  description: string | null;
  categoryName: string;
  categoryKey: string;
};

type Props = {
  merchantId: string;
  services: ServiceOffered[];
};

export const ServicesOffered = ({ merchantId, services }: Props) => {
  const { t } = useTranslation();
  if (services.length === 0) return null;

  return (
    <div>
      <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-text-full">
        <ActivityIcon className="h-5 w-5 text-accent" />
        {t("MerchantDetail.services-offered")}
      </h2>
      <div className="mt-5 grid gap-4 sm:grid-cols-2">
        {services.map(service => (
          <div
            key={`${service.categoryKey}-${service.name}`}
            className="flex flex-col rounded-xl border border-border-shell/60 dark:border-transparent bg-surface-blank p-5 shadow-simple"
          >
            <p className="font-heading text-xs font-bold uppercase tracking-[0.12em] text-accent">
              {service.categoryName}
            </p>
            <h3 className="mt-2 font-heading font-bold text-text-full">
              {service.name}
            </h3>
            {service.description && (
              <p className="mt-2 line-clamp-2 flex-1 text-sm text-text-light">
                {service.description}
              </p>
            )}
            <Link
              to={`/services/${service.categoryKey}/${merchantId}`}
              className="mt-4 inline-flex items-center gap-1 self-start rounded-lg border border-border-shell px-4 py-2 font-heading text-xs font-semibold uppercase tracking-wider text-text-medium transition hover:bg-surface-elevated hover:text-text-full"
            >
              {t("MerchantDetail.view-details")}
              <ArrowRightIcon className="h-3.5 w-3.5" />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
